/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100220 配送ルート割付マスタメンテ
 */
import { Column } from "@material-table/core";
import {
  B000150TokuiNm1,
  B000151NonyuNm1,
  B000224HaisorouteNmByHeaderHaisorouteNo,
  B100220Create,
  B100220CreateRequest,
  B100220Delete,
  B100220DeleteRequest,
  B100220Find,
  B100220FindRequest,
  B100220Update,
  B100220UpdateRequest,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SConfirmDialog,
  SConfirmDialogAction,
  SEntryTab,
  SFileButton,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { getSCode, SCode, ShohinshubetsuKbn } from "messages/codes";
import { labels } from "messages/labels";
import { B000150, B000151, B000224, B100223 } from "pages";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { mapIds } from "services";
import { focusState, navigateTypeState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
// ヘッダ部
type Fields = Partial<{
  headerHaisorouteNo: string;
  haisorouteNm: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  shohinshubetsuKbn: SCode;
}>;

// 明細入力部
type MeiFields = Partial<{
  tab: boolean;
  haisorouteNo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  defaultHaisojuni: string;
  haisojuni: string;
  version: number;
}>;

//テーブルデータの定義
type Data = Partial<{
  gyoNo: number;
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  haisorouteNo: string;
  haisojuni: string;
  version: number;
}>;

// フィールドの初期値を設定する。
// ヘッダ部
const defaultFields: Fields = {
  headerHaisorouteNo: "",
  haisorouteNm: "",
  tokuiCd: "",
  tokuishitenCd: "",
  tokuiNm: "",
  shohinshubetsuKbn: getSCode(ShohinshubetsuKbn, "1"),
};

// 明細入力部
const defaultMeiFields: MeiFields = {
  tab: true,
  haisorouteNo: "",
  tokuiCd: "",
  tokuishitenCd: "",
  nonyuCd: "",
  nonyushitenCd: "",
  nonyuNm: "",
  defaultHaisojuni: "",
  haisojuni: "",
  version: undefined,
};

const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "3rem", align: "right" },
  { field: "tokuiCd", title: "得意先コード", width: "3rem" },
  { field: "tokuishitenCd", title: "", width: "3rem" },
  { field: "nonyuCd", title: "納入先コード", width: "3rem" },
  { field: "nonyushitenCd", title: "", width: "3rem" },
  { field: "nonyuNm", title: "納入先名", width: "15rem" },
  { field: "haisojuni", title: "配送順位", width: "3rem" },
  { field: "haisorouteNo", hidden: true },
  { field: "version", hidden: true },
];

const focusId = "B100220";

// B100220 配送ルート割付マスタメンテ
export const B100220 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  const meiMethods = useForm<MeiFields>({
    mode: "onBlur",
    defaultValues: defaultMeiFields,
  });

  // テーブル管理
  const tableRef = createRef();
  const [rows, setRows] = useState<Data[]>([]);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移
  const navigate = useNavigate();
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);
  // 更新確認ダイアログオープン用
  const [openUpdateConfirm, setOpenUpdateConfirm] = useState(false);
  // 削除確認ダイアログオープン用
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  // 活性設定
  // 編集タブかどうか
  const isHenshu = meiMethods.watch("tab") === false;

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 検索フォームのデータを取得する。
    const fields = methods.getValues();

    // 検索パラメータを作成する。
    const param: B100220FindRequest = {
      haederHaisorouteNo: fields.headerHaisorouteNo!,
      tokuiCd: fields.tokuiCd,
      tokuishitenCd: fields.tokuishitenCd,
      shohinshubetsuKbn: fields.shohinshubetsuKbn?.value,
    };

    // API呼び出し
    B100220Find(param)
      // 正常取得時
      .then((value) => {
        // グリッドへのマッピング
        const gridDataList = value.data.map<Data>((value, index) => {
          // 行番号
          const gyoNo: number = index + 1;
          // 行のデータセット
          const data: Data = {
            gyoNo: Number(gyoNo),
            tokuiCd: value.tokuiCd,
            tokuishitenCd: value.tokuishitenCd,
            nonyuCd: value.nonyuCd,
            nonyushitenCd: value.nonyushitenCd,
            nonyuNm: value.nonyuNm,
            haisorouteNo: value.haisorouteNo,
            haisojuni: value.haisojuni,
            version: value.version,
          };
          return data;
        });
        // テーブルに反映
        setRows(gridDataList);
      })
      // エラー時
      .catch((reason) => {
        setRows([]);
        catchRestError(reason, navigate, setMsg);
      });
  };

  // タブ切り替え
  const handleChangeTab = () => {
    // 行選択解除
    setRowData(undefined);
    // 明細入力部の値を初期化
    meiMethods.reset();
  };

  // 登録
  const handleCreate = () => {
    // タブ部のデータ取得
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();

    // 新規登録するデータの作成
    const param: B100220CreateRequest = {
      tokuiCd: meiFields.tokuiCd!,
      tokuishitenCd: meiFields.tokuishitenCd!,
      nonyuCd: meiFields.nonyuCd!,
      nonyushitenCd: meiFields.nonyushitenCd!,
      headerHaisorouteNo: fields.headerHaisorouteNo!,
      haisojuni: meiFields.haisojuni!,
      shohinshubetsuKbn: fields.shohinshubetsuKbn?.value!,
    };

    B100220Create(param)
      .then(() => {
        // 新規登録したデータの行追加
        addRow(param);
        // タブ部の各項目を初期化する
        meiMethods.reset();
        // 登録完了メッセージ表示
        setMsg(getClientMessage("B100220_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 更新確認ダイアログ表示
  const handleOpenUpdateConfirm = () => {
    setOpenUpdateConfirm(true);
  };

  // 削除確認ダイアログキャンセル
  const handleCancelUpdateConfirm = () => {
    setOpenUpdateConfirm(false);
  };

  // 更新
  const handleUpdate = () => {
    setOpenUpdateConfirm(false);
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();

    // 更新するデータの作成
    const param: B100220UpdateRequest = {
      tokuiCd: meiFields.tokuiCd!,
      tokuishitenCd: meiFields.tokuishitenCd!,
      nonyuCd: meiFields.nonyuCd!,
      nonyushitenCd: meiFields.nonyushitenCd!,
      haisorouteNo: meiFields.haisorouteNo!,
      defaultHaisojuni: meiFields.defaultHaisojuni!,
      haisojuni: meiFields.haisojuni!,
      version: meiFields.version!,
    };

    B100220Update(param)
      .then(() => {
        // 更新した行の表示更新
        updateRow(rowData, fields, meiFields);
        // タブ部の初期化
        meiMethods.reset();
        // 更新完了メッセージ表示
        setMsg(getClientMessage("B100220_002"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 削除確認ダイアログ表示
  const handleOpenDeleteConfirm = () => {
    setOpenDeleteConfirm(true);
  };

  // 削除確認ダイアログキャンセル
  const handleCancelDeleteConfirm = () => {
    setOpenDeleteConfirm(false);
  };

  // 削除
  const handleDelete = () => {
    setOpenDeleteConfirm(false);

    const meiFields = meiMethods.getValues();

    const param: B100220DeleteRequest = {
      tokuiCd: meiFields.tokuiCd!,
      tokuishitenCd: meiFields.tokuishitenCd!,
      nonyuCd: meiFields.nonyuCd!,
      nonyushitenCd: meiFields.nonyushitenCd!,
      haisorouteNo: meiFields.haisorouteNo!,
      haisojuni: meiFields.haisojuni!,
    };

    B100220Delete(param)
      .then(() => {
        // 選択行の削除処理
        // 選択行の行番号取得
        const gyoNo = rowData?.gyoNo;
        // 取得した行番号の行を除いた全てのデータを取得
        const newRows = rows.filter(function (source: Data) {
          return source.gyoNo !== gyoNo;
        });
        // 明細テーブルの行番号振り直し
        mapIds(newRows, "gyoNo");
        // 削除後のデータセット
        setRows(newRows);
        // 明細入力部の初期化
        meiMethods.reset();
        // タブを新規にする
        meiMethods.setValue("tab", true);
        // 削除完了メッセージを表示する。
        setMsg(getClientMessage("B100220_003"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (rowData: Data) => {
    meiMethods.reset();
    // タブを編集にする
    meiMethods.setValue("tab", false);
    // ダブルクリックした行を選択状態にする
    setRowData(rowData);
    // 明細入力部にデータを表示する。
    meiMethods.setValue("haisorouteNo", rowData.haisorouteNo);
    meiMethods.setValue("tokuiCd", rowData.tokuiCd);
    meiMethods.setValue("tokuishitenCd", rowData.tokuishitenCd);
    meiMethods.setValue("nonyuCd", rowData.nonyuCd);
    meiMethods.setValue("nonyushitenCd", rowData.nonyushitenCd);
    meiMethods.setValue("nonyuNm", rowData.nonyuNm);
    meiMethods.setValue("defaultHaisojuni", rowData.haisojuni);
    meiMethods.setValue("haisojuni", rowData.haisojuni);
    meiMethods.setValue("version", rowData.version);
  };

  // 新規登録行の追加
  const addRow = (newData: B100220CreateRequest) => {
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();
    const gyoNo: number = rows.length + 1;
    const newRowData: Data = {
      gyoNo: gyoNo,
      tokuiCd: newData.tokuiCd,
      tokuishitenCd: newData.tokuishitenCd,
      nonyuCd: newData.nonyuCd,
      nonyushitenCd: newData.nonyushitenCd,
      nonyuNm: meiFields.nonyuNm,
      haisojuni: newData.haisojuni,
      haisorouteNo: fields.headerHaisorouteNo,
      version: 1,
    };

    setRows([...rows, newRowData]);
  };

  // 行の更新
  const updateRow = (rowData: any, fields: Fields, meiFields: MeiFields) => {
    // 明細入力部の反映
    const gyoNo: number = rowData.gyoNo!;
    const changedRowData: Data = {
      gyoNo: gyoNo,
      tokuiCd: meiFields.tokuiCd,
      tokuishitenCd: meiFields.tokuishitenCd,
      nonyuCd: meiFields.nonyuCd,
      nonyushitenCd: meiFields.nonyushitenCd,
      nonyuNm: meiFields.nonyuNm,
      haisojuni: meiFields.haisojuni,
      haisorouteNo: fields.headerHaisorouteNo,
      version: meiFields.version! + 1,
    };

    // 明細を設定
    rows[gyoNo - 1] = changedRowData;
    setRows([...rows]);
  };

  //excelボタンクリック時
  const handleMoveOutput = () => {
    // 配送ルート割付マスタ出力画面へ遷移する。
    setMenuNavigate("next");
    navigate("/b100223");
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="配送ルート割付マスタメンテ"
          gridTemplateColumns="8rem 6rem 6rem 13rem 7rem 10rem 5rem"
        >
          <SText gridColumn="span 6"></SText>
          <SFileButton
            label={labels.buttons.excel}
            align="right"
            {...register(5)}
            onClick={handleMoveOutput}
          />

          <SLabel required gridColumn="1">
            配送ルート番号
          </SLabel>
          <SNumberField
            name="headerHaisorouteNo"
            label="配送ルート番号"
            code
            required
            size={6}
            {...register(1)}
            onBlur={() => {
              B000224HaisorouteNmByHeaderHaisorouteNo(
                methods,
                navigate,
                setMsg
              );
            }}
            dialog={<B000224 />}
            handleSubmit={(data: any) => {
              methods.setValue("headerHaisorouteNo", data.haisorouteNo);
              methods.setValue("haisorouteNm", data.haisorouteNm);
            }}
          />
          <STextField
            name="haisorouteNm"
            label="配送ルート名"
            disabled
            gridColumn="span 2"
          />

          <SLabel gridColumn="1">得意先コード</SLabel>
          <SNumberField
            name="tokuiCd"
            label="得意先コード"
            code
            size={6}
            {...register(2)}
            onBlur={() => B000150TokuiNm1(methods, navigate, setMsg)}
          />
          <SNumberField
            name="tokuishitenCd"
            label="得意先支店コード"
            code
            size={4}
            {...register(3)}
            onBlur={() => B000150TokuiNm1(methods, navigate, setMsg)}
            dialog={<B000150 />}
            handleSubmit={(data: any) => {
              methods.setValue("tokuiCd", data.tokuiCd);
              methods.setValue("tokuishitenCd", data.tokuishitenCd);
              methods.setValue("tokuiNm", data.tokuiNmr);
            }}
          />
          <STextField name="tokuiNm" disabled />

          <SLabel gridColumn="1">商品種別</SLabel>
          <SCodeSelect
            name="shohinshubetsuKbn"
            options={ShohinshubetsuKbn}
            {...register(4)}
            gridColumn="span 2"
          />

          <SNormalButton
            gridColumn="7"
            gridRow="5"
            onClick={handleClickSearchButton}
            label={labels.buttons.search}
            align="right"
            {...register(7)}
          />
        </SFrame>
      </FormProvider>

      <SFrame>
        <STable
          keyName="gyoNo"
          data={rows}
          columns={columns}
          tableRef={tableRef}
          handleDoubleClick={handleDoubleClickTableRow}
          width={900}
          height={430}
          pageSize={15}
        />
      </SFrame>

      <FormProvider {...meiMethods}>
        <SFrame>
          <SEntryTab name="tab" handleOk={handleChangeTab}></SEntryTab>
          <SFrame gridTemplateColumns="6rem 6rem 6rem 6rem 25rem 5rem">
            <SLabel required gridColumn="span 2">
              得意先コード
            </SLabel>
            <SLabel required gridColumn="span 2">
              納入先コード
            </SLabel>
            <SLabel>納入先名</SLabel>
            <SLabel>配送順位</SLabel>
            <SNumberField
              name="tokuiCd"
              label="得意先コード"
              code
              size={6}
              {...register(8)}
              disabled={isHenshu}
            />
            <SNumberField
              name="tokuishitenCd"
              label="得意先支店コード"
              code
              size={4}
              {...register(9)}
              dialog={<B000150 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("tokuiCd", data.tokuiCd);
                meiMethods.setValue("tokuishitenCd", data.tokuishitenCd);
              }}
              disabled={isHenshu}
            />

            <SNumberField
              name="nonyuCd"
              label="納入先コード"
              code
              size={6}
              {...register(10)}
              disabled={isHenshu}
              onBlur={() => B000151NonyuNm1(meiMethods, navigate, setMsg)}
            />
            <SNumberField
              name="nonyushitenCd"
              label="納入先支店コード"
              code
              size={4}
              {...register(11)}
              onBlur={() => B000151NonyuNm1(meiMethods, navigate, setMsg)}
              dialog={<B000151 />}
              handleSubmit={(data: any) => {
                meiMethods.setValue("nonyuCd", data.nonyuCd);
                meiMethods.setValue("nonyushitenCd", data.nonyushitenCd);
                meiMethods.setValue("nonyuNm", data.tokuiNm1);
              }}
              disabled={isHenshu}
            />
            <STextField name="nonyuNm" label="納入先名" disabled />
            <SNumberField
              name="haisojuni"
              label="配送順位"
              code
              size={4}
              {...register(12)}
            />

            {meiMethods.getValues().tab === true ? (
              <>
                <SNormalButton
                  label={labels.buttons.create}
                  gridRow="3"
                  gridColumn="6"
                  align="right"
                  {...register(13)}
                  dialog={
                    <SConfirmDialog
                      title={labels.dialog.createMasterTitle}
                      msg={labels.dialog.createConfirm}
                    />
                  }
                  dialogAction="confirm"
                  handleSubmit={handleCreate}
                />
              </>
            ) : (
              <>
                <SCancelButton
                  label={labels.buttons.linedeletion}
                  gridRow="3"
                  align="left"
                  {...register(14)}
                  onClick={handleOpenDeleteConfirm}
                />
                <SNormalButton
                  label={labels.buttons.update}
                  gridRow="3"
                  gridColumn="6"
                  align="right"
                  {...register(15)}
                  onClick={handleOpenUpdateConfirm}
                />
              </>
            )}
          </SFrame>
        </SFrame>
        <SConfirmDialogAction
          title={labels.dialog.updateMasterTitle}
          msg={labels.dialog.updateConfirm}
          onOk={handleUpdate}
          onCancel={handleCancelUpdateConfirm}
          isOpen={openUpdateConfirm}
        />
        <SConfirmDialogAction
          title={labels.dialog.deleteMasterTitle}
          msg={labels.dialog.deleteConfirm}
          onOk={handleDelete}
          onCancel={handleCancelDeleteConfirm}
          isOpen={openDeleteConfirm}
        />
      </FormProvider>
    </>
  );
};
